import styled from 'styled-components';

import { Card } from 'semantic-ui-react';
import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Dialog = styled(Card)`
  &.ui.card {
    padding: 30px 40px;
    height: auto;
    width: 100%;
    max-width: ${({ maxWidth }) => (maxWidth || '600px')};
    min-width: 440px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Text = styled(TextLayoutComponent)`
  font-size: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ConfirmButton = styled(ButtonLayoutComponent)`
  height: 41px;
  &&& {
    margin-right: 10px;
    min-width: 150px;
  }
`;

const CancelButton = styled(ButtonLayoutComponent.Inverted)`
  height: 41px;
  &&& {
    margin-left: 10px;
    min-width: 150px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 35px;
`;

export {
  CancelButton,
  ButtonContainer,
  Container,
  ContentContainer,
  Dialog,
  ConfirmButton,
  Text,
};
